import { DialogDraggable } from '@bloomfieldrobotics/canopy';
import { DialogContent, IconButton } from '@mui/material';
import { useState } from 'react';
import { useBlock } from '../../../../services/entities/hooks/useBlock';
import { useRanch } from '../../../../services/entities/hooks/useRanch';
import { MapControl } from '../../../commonUI/maps/controls';
import DebugInfoSection from '../../../debugInfo/components/DebugInfoSection';
import DebugInfo from '../../../debugInfo/DebugInfo';
import { DebugIcon } from '../../../navbar/components/icons/DebugIcon';
import { BlockPointData } from '../hooks/useGetBlockPoints';

type Props = {
  blockId: string;
  scanId: string;
  points: BlockPointData[] | null;
  selectedPoint: BlockPointData | undefined;
};

export const DebugInfoLauncherControl = ({
  blockId,
  scanId,
  points,
  selectedPoint,
}: Props) => {
  const [open, setOpen] = useState(false);

  const { block } = useBlock(blockId);
  const { ranch } = useRanch(block?.ranchID);

  return (
    <>
      <MapControl
        sx={{
          position: 'absolute',
          left: 8,
          bottom: 8,
          zIndex: 2, // goes above mapbox watermark
          padding: 1,
        }}
      >
        <IconButton onClick={() => setOpen(true)}>
          <DebugIcon />
        </IconButton>
      </MapControl>
      <DialogDraggable
        open={open}
        onClose={() => setOpen(false)}
        title='Debug Info'
      >
        <DialogContent>
          <DebugInfo
            customerID={ranch?.customerID}
            ranchID={block?.ranchID}
            blockID={blockId}
            scanID={scanId}
          >
            <DebugInfoSection
              sectionLabel='Point ID / Scan Data'
              isLoading={false}
              jsonObjectOrArrayOfObjects={selectedPoint ?? points ?? []}
              showID={!!selectedPoint?.id}
              id={selectedPoint?.id}
            />
          </DebugInfo>
        </DialogContent>
      </DialogDraggable>
    </>
  );
};
